import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import { inject, observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';

import { createForm } from '../../../models/Form';
import Field from '../../form/Field';
import globalTranslations from '../../../i18n/globalTranslations';
import { notBlank } from '../../../util/formValidators';
import { createFormField } from '../../../models/FormField';
import FieldError from '../../form/FieldError';
import Icon from "../../common/Icon";
import FormFieldId from "../../../types/FormFieldId";
import { modelOf } from "../../../prop-types";
import CheckoutStore from "../../../store/CheckoutStore";

const LoginForm = ({ checkoutStore, onSubmit, loading }) => {
  const { order } = checkoutStore;
  const userNameField = order?.customer_fields.get(FormFieldId.BILLING_EMAIL);
  const userNameValue = userNameField?.value || '';

  const form = useMemo(() => createForm({
    username: createFormField({
      value: userNameValue
    }, [
      notBlank(<FormattedMessage {...globalTranslations.emailOrUsernameTitle} />),
    ]),
    password: createFormField({}, [
      notBlank(<FormattedMessage {...globalTranslations.passwordTitle} />),
    ]),
  }), []);

  const handleSubmit = (e) => {
    e.preventDefault();
    form.validate();
    if (form.valid && onSubmit) {
      onSubmit(form.getFieldValues());
    }
  };

  return (
    <Form className="LoginForm" noValidate onSubmit={handleSubmit}>
      <FormGroup>
        <Label for="LoginForm__username">
          <FormattedMessage {...globalTranslations.emailOrUsernameTitle} />
        </Label>
        <Field
          component={Input}
          field={form.fields.get('username')}
          type="text"
          name="username"
          id="LoginForm__username"
          autoComplete="username"
          autoCorrect="off"
          autoCapitalize="none"
        />
        <FieldError field={form.fields.get('username')} />
      </FormGroup>
      <FormGroup>
        <Label for="LoginForm__password">
          <FormattedMessage {...globalTranslations.passwordTitle} />
        </Label>
        <Field
          component={Input}
          field={form.fields.get('password')}
          type="password"
          name="password"
          id="LoginForm__password"
          autoComplete="current-password"
        />
        <FieldError field={form.fields.get('password')} />
      </FormGroup>
      <Button
        color="primary"
        block
        disabled={form.valid === false || loading}
      >
        <Icon
          name={loading ? 'circle-o-notch' : 'sign-in'}
          spin={loading}
        />
        <FormattedMessage {...globalTranslations.logInSentence} />
      </Button>
    </Form>
  );
};

LoginForm.propTypes = {
  checkoutStore: modelOf(CheckoutStore).isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default inject(
  'checkoutStore',
)(observer(LoginForm));
